import React from 'react';
import CoreModal, { ModalProps } from 'styled-react-modal';
import styled from 'styled-components';
import UnstyledButton from '../Buttons/UnstyledButton';
import { themeColor } from '../../Theming';
import { mobileMediaQuery } from '../../Theming';
import { useTranslation } from 'react-i18next';
import Close from '../Icons/Close';

interface ModalWrapperProps extends ModalProps {
  mobileWidth?: number;
  mobileHeight?: number;
  onClose?(): void;
}

const StyledModal = CoreModal.styled``;

const CloseButton = styled(UnstyledButton)`
  position: absolute;
  top: 20px;
  right: 20px;
  padding: 5px;
  ${mobileMediaQuery} {
    top: 5px;
    right: 5px;
  }
`;

const Wrapper: React.FC<ModalWrapperProps> = ({
  onClose,
  onEscapeKeydown,
  onBackgroundClick,
  ...props
}) => {
  const handleEscapeKeydown = onEscapeKeydown ?? onClose;
  const handleBackgroundClick = onBackgroundClick ?? onClose;
  const { t } = useTranslation();

  return (
    <StyledModal
      onEscapeKeydown={handleEscapeKeydown}
      onBackgroundClick={handleBackgroundClick}
      {...props}
    >
      {onClose && (
        <CloseButton
          onClick={onClose}
          aria-label={t('general.accessibility.close')}
        >
          <Close width={16} height={16} />
        </CloseButton>
      )}
      {props.children}
    </StyledModal>
  );
};

const Modal = styled(Wrapper)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${themeColor('white')};
  border-radius: 4px;
  min-width: 300px;
  padding: 40px 40px 20px;
  ${mobileMediaQuery} {
    margin: 4px;
  }
`;

export default Modal;
